import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import api from '@/lib/api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying');

  useEffect(() => {
    if (!token) { setStatus('invalid'); return; }
    api.get(`/auth/verify-email?token=${token}`)
      .then(() => setStatus('success'))
      .catch(err => {
        const msg = err.response?.data?.detail || '';
        setStatus(msg.includes('expired') ? 'expired' : 'invalid');
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-white" data-testid="verify-email-page">
      <div className="text-center max-w-md">
        <div className="relative inline-block mb-8">
          <img src="/logo_transparent.png" alt="RentalHub" className="object-contain mx-auto block" style={{ width: '90vw', maxWidth: '700px', height: 'auto' }} />
        </div>

        {status === 'verifying' && (
          <>
            <Loader2 className="w-12 h-12 text-slate-400 animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-bold text-slate-900 mb-2">Verifying your email...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Email Verified!</h2>
            <p className="text-sm text-slate-500 mb-6">Your email address has been verified. You can now sign in.</p>
            <Link to="/login" className="inline-block px-6 py-3 bg-slate-900 hover:bg-slate-800 text-white rounded-lg font-semibold text-sm" data-testid="verify-login-link">
              Sign In
            </Link>
          </>
        )}
        {status === 'invalid' && (
          <>
            <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Invalid Link</h2>
            <p className="text-sm text-slate-500 mb-6">This verification link is invalid or has already been used.</p>
            <Link to="/login" className="text-sm text-slate-700 font-medium hover:underline">Back to Sign In</Link>
          </>
        )}
        {status === 'expired' && (
          <>
            <XCircle className="w-16 h-16 text-amber-400 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Link Expired</h2>
            <p className="text-sm text-slate-500 mb-6">This verification link has expired. Please request a new one from the login page.</p>
            <Link to="/login" className="text-sm text-slate-700 font-medium hover:underline">Back to Sign In</Link>
          </>
        )}
      </div>
    </div>
  );
}
